import { DEFAULT_TEXT_FIELDS, HEADER_FIELDS } from './consts';

// `name` is stringified because the platform dictionary uses numeric ids, and 0 (Web) would
// otherwise be dropped everywhere it is tested for truthiness.
export const toOption = item => ({ label: item.display_name, value: String(item.name) });

export const toOptions = (items = []) => items.map(toOption);

// The endpoint treats an empty value as "not provided", so every key is always sent - matching the
// legacy `$.param` payload exactly.
export const buildSubmitParams = ({ defaults = {}, headers = {}, filename = '', isRefund = false }) => {
    const params = new URLSearchParams();

    params.set('adnetwork', defaults.adnetwork || '');
    params.set('app', defaults.app || '');
    params.set('platform', defaults.platform || '');

    DEFAULT_TEXT_FIELDS.forEach(({ key, param }) => params.set(param, defaults[key] || ''));

    params.set('filename', filename);
    params.set('is_refund', String(Boolean(isRefund)));

    HEADER_FIELDS.forEach(({ key, param }) => params.set(param, headers[key] || ''));

    return params.toString();
};
